module.exports = __webpack_public_path__ + "static/badkamer-fbb16e895cdcb70541f77fe8c52cdea0.jpg";